import { url, modules, sysRole } from 'configs/';
import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { SUCCESS } from 'containers/App/configureStore';
import { camelizeKeys } from 'humps';
import { isJsonString } from 'utils/index';
import { TIMEZONE_INFO } from 'constant/index';

const {
  SECURITY,
  NEWTUBE_API_SERVER,
} = url;

const NAMESPACE = 'tube/app/user/';
const FETCH_USER_DATA = `${NAMESPACE}FETCH_USER_DATA`;
const FETCH_USER_PICTURE = `${NAMESPACE}FETCH_USER_PICTURE`;
const PUT_IDNUMBERVERIFY = `${NAMESPACE}PUT_IDNUMBERVERIFY`;

const moduleAuth = {};
for (const key in modules) {
  if (modules.hasOwnProperty(key)) {
    moduleAuth[`use${modules[key].authName}`] = false;
  }
}

const functionRole = {};
for (const key in sysRole) {
  if (sysRole.hasOwnProperty(key)) {
    functionRole[`is${sysRole[key]}`] = false;
  }
}

const initialState = {
  isLoaded: false,
  isVerify: false,
  isSupervisor: false,
  userDisplayName: undefined,
  moduleAuth,
  functionRole,
  employeeId: undefined,
  groupId: '',
  personalPicture: '',
};

export default typeToReducer({
  [FETCH_USER_PICTURE]: {
    [SUCCESS]: (state, action) => {
      const response = isJsonString(action.payload.data) ? camelizeKeys(JSON.parse(action.payload.data)) : action.payload.data;
      const newState = {
        personalPicture: response.data,
      };
      return Object.assign({}, state, newState);
    },
  },
  [FETCH_USER_DATA]: {
    [SUCCESS]: (state, action) => {
      const response = isJsonString(action.payload.data) ? camelizeKeys(JSON.parse(action.payload.data)) : action.payload.data;
      const newModuleAuth = Object.assign({}, state.moduleAuth);
      const newFunctionRole = Object.assign({}, state.functionRole);

      axios.defaults.headers.common['Accept-Language'] = response.data.language;
      localStorage.setItem('locale', response.data.language);
      response.data.userModule.forEach((moduleKey) => {
        if (modules[moduleKey] === undefined) {
          return;
        }
        newModuleAuth[`use${modules[moduleKey].authName}`] = true;
      });

      response.data.userRole.forEach((roleKey) => {
        if (sysRole[roleKey] === undefined) {
          return;
        }
        newFunctionRole[`is${sysRole[roleKey]}`] = true;
      });
      sessionStorage.employee_id = response.data.employeeId;
      const timezone =
        TIMEZONE_INFO[response.data.companyTimeZone] ||
        new Intl.DateTimeFormat().resolvedOptions().timeZone;
      const newState = {
        iDTypeNameByUserLanguage: response.data.iDTypeNameByUserLanguage,
        userDisplayName: response.data.userName,
        isVerify: response.data.isVerify,
        isSupervisor: response.data.isSupervisor,
        moduleAuth: newModuleAuth,
        functionRole: newFunctionRole,
        isLoaded: true,
        allowModules: response.data.userModule,
        employeeId: response.data.employeeId,
        companyCode: response.data.companyCode,
        employeeNumber: response.data.employeeNumber,
        groupId: response.data.groupId,
        companyTimeZone: response.data.companyTimeZone,
        timezone,
        dateFormat: response.data.dateFormat,
      };

      return Object.assign({}, state, newState);
    },
  },
}, initialState);

export function fetchUserPictureUrl() {
  return dispatch => {
    return dispatch({
      type: FETCH_USER_PICTURE,
      payload: axios.get(`${NEWTUBE_API_SERVER}users/personalPicture`).then((resp) => {
        return resp;
      }),
    });
  };
}

export function fetchAllUserInfo() {
  return {
    type: FETCH_USER_DATA,
    payload: axios.get(`${NEWTUBE_API_SERVER}userInfo`),
  };
}

export function logout(loginPath, reason) {
  // 分鐘級 new mode 才有 tokenExpireAt；天級沒有此 key。必須在清 localStorage 前先抓。
  const isMinuteLevel = !!window.localStorage.getItem('tokenExpireAt');
  const locale = sessionStorage.locale;
  sessionStorage.clear();
  window.localStorage.clear();
  const reasonParam = (reason && isMinuteLevel) ? `&logoutReason=${encodeURIComponent(reason)}` : '';
  if (loginPath) {
    location.href = `${SECURITY}account/logout?original_target=${encodeURIComponent(location.origin + loginPath)}&lang=${locale}${reasonParam}`;
  } else {
    location.href = `${SECURITY}account/logout?original_target=${encodeURIComponent(location.href)}&lang=${locale}${reasonParam}`;
  }
  return true;
}

export function putIdNumberVerify(value) {
  return {
    type: PUT_IDNUMBERVERIFY,
    payload: axios.put(
      '/users/account/verify',
      {
        idNumber: value,
      },
      {
        baseURL: NEWTUBE_API_SERVER,
      }
    ),
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/reducers/userReducer.js
 **/